var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContainer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.4,6.8L22.4,6.8l-1.8-3.1c-0.1-0.1-0.2-0.2-0.3-0.2h-1c-0.1,0-0.2,0-0.3,0.1L18.7,4H5.3L5,3.7C4.9,3.6,4.8,3.6,4.7,3.6 H3.6c-0.1,0-0.3,0.1-0.3,0.2l-1.6,3l-0.1,0C1.5,6.9,1.4,7.2,1.4,7.2v11c0,0.1,0,0.1,0.1,0.2L2,19.3c0.1,0.1,0.2,0.2,0.3,0.2h1.5 c0.1,0,0.3-0.1,0.3-0.2L4.3,19h15.4l0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.2h1.5c0.1,0,0.2-0.1,0.3-0.2l0.5-0.8c0-0.1,0.1-0.1,0.1-0.2V7.2 C22.6,7,22.5,6.9,22.4,6.8z M4.2,5.2l0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1h14.5c0.1,0,0.2,0,0.3-0.1l0.2-0.3l0.5,1.3 c0,0-0.4,0.4-0.4,0.4H4.2L3.8,6.5c0,0-0.1,0-0.1-0.1L4.2,5.2z M20.9,17.8l-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2H3.6 c-0.1,0-0.3,0.1-0.3,0.2l-0.2,0.3h0V8h0l0.3,0.3c0.1,0.1,0.2,0.1,0.3,0.1h16.8c0.1,0,0.2,0,0.3-0.1L21,8.2L20.9,17.8L20.9,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3,9.5H5c-0.3,0-0.7,0-0.7,0.6v5.7c0,0.6,0.4,0.6,0.7,0.6h0.4c0.3,0,0.7,0,0.7-0.6v-5.7C6,9.5,5.6,9.5,5.3,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,9.5H7.7c-0.3,0-0.7,0-0.7,0.6v5.7c0,0.6,0.4,0.6,0.7,0.6h0.4c0.3,0,0.7,0,0.7-0.6v-5.7C8.7,9.5,8.3,9.5,8.1,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,9.5h-0.4c-0.3,0-0.7,0-0.7,0.6v5.7c0,0.6,0.4,0.6,0.7,0.6h0.4c0.3,0,0.7,0,0.7-0.6v-5.7C11.5,9.5,11.1,9.5,10.8,9.5z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,9.5h-0.4c-0.3,0-0.7,0-0.7,0.6v5.7c0,0.6,0.4,0.6,0.7,0.6h0.4c0.3,0,0.7,0,0.7-0.6v-5.7C14.2,9.5,13.8,9.5,13.6,9.5z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3,9.5h-0.4c-0.3,0-0.7,0-0.7,0.6v5.7c0,0.6,0.4,0.6,0.7,0.6h0.4c0.3,0,0.7,0,0.7-0.6v-5.7C16.9,9.5,16.6,9.5,16.3,9.5z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,9.5h-0.4c-0.3,0-0.7,0-0.7,0.6v5.7c0,0.6,0.4,0.6,0.7,0.6H19c0.3,0,0.7,0,0.7-0.6v-5.7C19.7,9.5,19.3,9.5,19,9.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContainer);
export default __webpack_public_path__ + "static/media/icon-container.8dadf00442f259880c4033e328e61e4b.svg";
export { ForwardRef as ReactComponent };